import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["onSortApply", "numberOfSortItems", "classNames", "shouldCloseOnOutsideClick"];
import React, { useCallback, useState } from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';
import _noop from 'lodash';
import { EMPTY_STRING } from '@tekion/tekion-base/app.constants';
import Popover from 'molecules/popover';
import Button from 'atoms/Button';
import PropertyControlledComponent from 'molecules/PropertyControlledComponent';
import withPopoverOutsideClickHandler from 'hoc/withPopoverOutsideClickHandler';
import MultiSort from '../../MultiSort';
import styles from './multiSortTrigger.module.scss';
var PopoverWithOutsideClickHandler = withPopoverOutsideClickHandler(Popover);
function MultiSortTriggerButton(_ref) {
  var onSortApply = _ref.onSortApply,
    numberOfSortItems = _ref.numberOfSortItems,
    classNames = _ref.classNames,
    shouldCloseOnOutsideClick = _ref.shouldCloseOnOutsideClick,
    restProps = _objectWithoutProperties(_ref, _excluded);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    showSortDialog = _useState2[0],
    setShowSortDialog = _useState2[1];
  var hasSelectedSortItems = numberOfSortItems > 0;
  var hideSortDialog = useCallback(function () {
    setShowSortDialog(false);
  }, [setShowSortDialog]);
  var toggleSortDialog = useCallback(function () {
    setShowSortDialog(!showSortDialog);
  }, [setShowSortDialog, showSortDialog]);
  var handleSortApply = useCallback(function (appliedSortItems) {
    onSortApply(appliedSortItems);
    setShowSortDialog(false);
  }, [onSortApply, setShowSortDialog]);
  var PopoverComponent = shouldCloseOnOutsideClick ? PopoverWithOutsideClickHandler : Popover;
  return /*#__PURE__*/React.createElement(PopoverComponent, {
    placement: "bottomLeft",
    visible: showSortDialog,
    destroyTooltipOnHide: true,
    trigger: "click",
    content: /*#__PURE__*/React.createElement(MultiSort, _extends({}, restProps, {
      onSortApply: handleSortApply,
      onClose: toggleSortDialog
    })),
    className: cx(styles.multiSortPopoverContainer, [_defineProperty({}, styles.selected, hasSelectedSortItems)], classNames),
    onOutsideClick: hideSortDialog
  }, /*#__PURE__*/React.createElement(Button, {
    view: Button.VIEW.TERTIARY,
    className: styles.multiSortTriggerContainer,
    onClick: toggleSortDialog
  }, /*#__PURE__*/React.createElement("div", {
    className: cx('icon-interchangeable', styles.sortIcon)
  }), /*#__PURE__*/React.createElement(PropertyControlledComponent, {
    controllerProperty: hasSelectedSortItems
  }, /*#__PURE__*/React.createElement("span", {
    className: styles.sortItemsCount
  }, numberOfSortItems))));
}
MultiSortTriggerButton.propTypes = {
  onSortApply: PropTypes.func,
  numberOfSortItems: PropTypes.number,
  classNames: PropTypes.string,
  toggleSortDialog: PropTypes.func,
  showSortDialog: PropTypes.bool,
  shouldCloseOnOutsideClick: PropTypes.bool
};
MultiSortTriggerButton.defaultProps = {
  onSortApply: _noop,
  numberOfSortItems: 0,
  classNames: EMPTY_STRING,
  toggleSortDialog: _noop,
  showSortDialog: false,
  shouldCloseOnOutsideClick: false
};
export default MultiSortTriggerButton;